import React from 'react'
import Aux from '../../../hoc/Auxillary'
import Button from '../../UI/Button/Button';
import './OrderSummary.scss'

const OrderSummary = (props) => {
    const ingredientSummary = Object.entries(props.ingredients);
    const orderSummary = [];
    for(let x = 0; x < ingredientSummary.length; x++) {
        orderSummary.push(
            <li className="firstCaps" key={ingredientSummary[x][0]}>{ingredientSummary[x][0]}: {ingredientSummary[x][1]}</li>
        )
    }

    return (
        <Aux>
            <h3>Your Order</h3>
            <p>A delicious burger with the following ingredients:</p>
            <ul>
                {orderSummary}
            </ul>
            <p><strong>Total Price: ${props.price.toFixed(2)}</strong></p>
            <p>Continue to checkout?</p>
            <Button btnType="Danger" clicked={props.purchaseCancelled}>NO</Button>
            <Button btnType="Success" clicked={props.purchaseContinued}>YES</Button>
        </Aux>
    )
}

export default OrderSummary
